/**
 * Accounts driven by automation (headless browsers, scripted signups) rather
 * than a person. Admin labels them "Bot" and leaves them out of its KPIs.
 *
 * The match is on the last user agent the profile saw. Scripted browsers can
 * fake a normal user agent, so this catches honest automation only; the
 * 2026-10-23 Taipei wave (19 signups) reported itself as HeadlessChrome.
 */
const BOT_USER_AGENT =
  /headlesschrome|headless|phantomjs|puppeteer|playwright|selenium|webdriver|lighthouse|\bbot\b|bot\/|googlebot|bingbot|duckduckbot|yandexbot|applebot|gptbot|facebookexternalhit|slurp|bingpreview|ahrefs|semrush|crawler|spider|python-requests|python-urllib|curl\/|wget|httpclient|scrapy/i;

export function isBotUserAgent(userAgent) {
  return BOT_USER_AGENT.test(String(userAgent || ''));
}

export function isBotAccount(user = {}) {
  return isBotUserAgent(user.lastUserAgent);
}
